import React, { createElement, useRef } from 'react';
import { Tag } from '@alifd/next';
import wrapper from '../next-wrapper';
import { useDeepCompareEffect, useEventEmitter } from 'ahooks';
import { drop, isEmpty } from 'lodash-es';
import EntityList from './entity-list';
import EntityTree from './entity-tree';
import AccountingEventList from './accounting-event-list';
export var TYPE;
(function (TYPE) {
    TYPE["ENTITY_TREE"] = "ENTITY_TREE";
    TYPE["ENTITY_LIST"] = "ENTITY_LIST";
    TYPE["RULE_ENGINE_LIST"] = "RULE_ENGINE_LIST";
    TYPE["RULE_CAT_LIST"] = "RULE_CAT_LIST";
    TYPE["ITEM_GRROUP_LIST"] = "ITEM_GRROUP_LIST";
    TYPE["ACCT_STAND_RULE_LIST"] = "ACCT_STAND_RULE_LIST";
    TYPE["ACCT_PARAM_LIST"] = "ACCT_PARAM_LIST";
    TYPE["ACCT_SERVICE_LIST"] = "ACCT_SERVICE_LIST";
    TYPE["ACCT_RULE_LIST"] = "ACCT_RULE_LIST";
    TYPE["ACCT_EVENT_LIST"] = "ACCT_EVENT_LIST";
    TYPE["BIZ_EVENT_LIST"] = "BIZ_EVENT_LIST";
    TYPE["ABSTRACT_LIST"] = "ABSTRACT_LIST";
    TYPE["SBJECT_LIST"] = "SBJECT_LIST";
    TYPE["ACCT_PARAM_ID_LIST"] = "ACCT_PARAM_ID_LIST";
    TYPE["ACCT_PARAM_ID_ITEM_LIST"] = "ACCT_PARAM_ID_ITEM_LIST";
    TYPE["ACCT_PARAM_ID_ABSTRACT_LIST"] = "ACCT_PARAM_ID_ABSTRACT_LIST";
    TYPE["ACCT_EVENT_ID_LIST"] = "ACCT_EVENT_ID_LIST";
    TYPE["ABSTRACT_ID_LIST"] = "ABSTRACT_ID_LIST";
    TYPE["SBJECT_ID_LIST"] = "SBJECT_ID_LIST";
    TYPE["ACCT_STAND_RULE_ID_LIST"] = "ACCT_STAND_RULE_ID_LIST";
    TYPE["ITEM_GRROUP_ID_LIST"] = "ITEM_GRROUP_ID_LIST";
    TYPE["ACCT_RULE_ID_LIST"] = "ACCT_RULE_ID_LIST";
    TYPE["DECISION_MAP_LIST"] = "DECISION_MAP_LIST";
})(TYPE || (TYPE = {}));
const ComponentMap = {
    ENTITY_TREE: EntityTree,
    ENTITY_LIST: EntityList,
    RULE_ENGINE_LIST: AccountingEventList,
    RULE_CAT_LIST: AccountingEventList,
    ITEM_GRROUP_LIST: AccountingEventList,
    ACCT_STAND_RULE_LIST: AccountingEventList,
    ACCT_PARAM_LIST: AccountingEventList,
    ACCT_SERVICE_LIST: AccountingEventList,
    ACCT_RULE_LIST: AccountingEventList,
    ACCT_EVENT_LIST: AccountingEventList,
    BIZ_EVENT_LIST: AccountingEventList,
    ABSTRACT_LIST: AccountingEventList,
    SBJECT_LIST: AccountingEventList,
    ACCT_PARAM_ID_LIST: AccountingEventList,
    ACCT_PARAM_ID_ITEM_LIST: AccountingEventList,
    ACCT_PARAM_ID_ABSTRACT_LIST: AccountingEventList,
    ACCT_EVENT_ID_LIST: AccountingEventList,
    ABSTRACT_ID_LIST: AccountingEventList,
    SBJECT_ID_LIST: AccountingEventList,
    ACCT_STAND_RULE_ID_LIST: AccountingEventList,
    ITEM_GRROUP_ID_LIST: AccountingEventList,
    ACCT_RULE_ID_LIST: AccountingEventList,
    DECISION_MAP_LIST: AccountingEventList
};
const ApiSelect = (props, ref) => {
    const { value, onChange, paramsMap = [], changingField = {}, field, type, ...restProps } = props;
    const subscribeFields = getSubcribeFields(paramsMap);
    const $event = useEventEmitter();
    const defaultFieldsRenderOnce = useRef(true);
    const changedFields = field.getValues() || {};
    useDeepCompareEffect(() => {
        const isAllFixedParams = isFixedParams(paramsMap);
        const subscribFieldsHasDefaultValue = subscribeFields.find((key) => key in changedFields && !!changedFields[key]);
        const subscribFieldsChanging = subscribeFields.find((key) => key in changingField);
        if (isAllFixedParams) {
            $event.emit();
        }
        else if (subscribFieldsHasDefaultValue && defaultFieldsRenderOnce.current) {
            $event.emit();
            defaultFieldsRenderOnce.current = false;
        }
        else if (subscribFieldsChanging) {
            $event.emit();
        }
    }, [$event, changedFields, changingField, paramsMap, subscribeFields]);
    const Component = ComponentMap[type];
    if (Component) {
        return (createElement(Component, { ...restProps, paramsMap: paramsMap, value: value, onChange: onChange, ref: ref, "$event": $event, field: field, type: type }));
    }
    return null;
};
export const FormApiSelectRef = React.forwardRef(ApiSelect);
const FormApiSelect = wrapper(FormApiSelectRef, 'CbayelFormApiSelect');
export default FormApiSelect;
export const parseParams = (paramsMap = [], field) => {
    const params = {};
    paramsMap.forEach((item) => {
        const { dataSourceType, name, refValue } = item;
        if (dataSourceType === 'FIXED') {
            params[name] = refValue;
        }
        else if (dataSourceType === 'FORM') {
            params[name] = field.getValue(refValue);
        }
    });
    return params;
};
const getSubcribeFields = (paramsMap = []) => {
    const subscribFields = [];
    paramsMap.forEach((item) => {
        const { dataSourceType, refValue } = item;
        if (dataSourceType === 'FORM') {
            subscribFields.push(refValue);
        }
    });
    return subscribFields;
};
const isFixedParams = (paramsMap = []) => {
    return paramsMap.every((item) => item.dataSourceType === 'FIXED');
};
export const transformSchema2tree = (schema = {}) => {
    if (!schema) {
        return [];
    }
    const { properties, type, items, pathPrefix = 'properties', dataPrefix = 'properties', parentType = 'object', parentDataPrefix = null, rootType = null, level = 0, } = schema;
    if (type === 'object') {
        const data = Object.keys(properties).map((key) => {
            const el = properties[key];
            const { type, description = '', required = false, dict, dataSourceType, refValue } = el;
            const _pathKey = [].concat(pathPrefix, key, 'properties').join('.');
            const _dataKey = [].concat(dataPrefix, type === 'array' ? `${key}[]` : key).join('.');
            const _parentdataKey = [].concat(dataPrefix, key).join('.');
            const options = {
                ...el,
                pathPrefix: _pathKey,
                dataPrefix: _dataKey,
                parentType: type,
                parentDataPrefix: _parentdataKey,
                rootType: type,
                level: level + 1,
                dataSourceType,
                refValue,
            };
            const children = transformSchema2tree(options).length === 0 ? null : transformSchema2tree(options);
            const label = () => {
                let color = 'blue';
                if (type !== 'object' || type !== 'array') {
                    color = 'green';
                }
                const title = isEmpty(description) ? `${key}` : `${key}(${description})`;
                return (createElement("div", { style: { display: 'flex' } },
                    createElement("div", { style: { marginRight: 8, fontWeight: 'bold' } }, title),
                    createElement("div", null,
                        createElement(Tag, { type: "primary", size: "small", color: color }, type))));
            };
            const value = drop(_dataKey.split('.')).join('.');
            return {
                key: _pathKey,
                type,
                name: key,
                required,
                description,
                parentKey: pathPrefix,
                parentType,
                dataKey: _dataKey,
                dict,
                parentDataPrefix,
                rootType: rootType || type,
                level,
                dataSourceType,
                refValue,
                label: label(),
                value,
                children,
            };
        });
        return data;
    }
    else if (type === 'array') {
        const arrayPrefix = pathPrefix.split('.');
        arrayPrefix.pop();
        const finalPrefix = [].concat(arrayPrefix, 'items', 'properties').join('.');
        return transformSchema2tree({
            ...items,
            pathPrefix: finalPrefix,
            dataPrefix,
            parentType,
            parentDataPrefix,
            rootType,
            level,
        });
    }
    return [];
};
